const defaultMessage = (length: number, valueLength: number) =>
    `Ensure this value has at least ${length} characters (it has ${valueLength}).`

export const MinLengthValidator =
    (length: number, message = defaultMessage) =>
    (value: string) => {
        return value && value.length >= length ? undefined : message(length, value.length)
    }
